__turbopack_context__.v({
  "calendar": "CalendarBase-module-scss-module__tC3sTG__calendar",
  "calendarPage": "CalendarBase-module-scss-module__tC3sTG__calendarPage",
  "wrapper": "CalendarBase-module-scss-module__tC3sTG__wrapper",
  "wrapperDisabled": "CalendarBase-module-scss-module__tC3sTG__wrapperDisabled",
});
